import React, { useState } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Label } from '../components/ui/label';
import { Card } from '../components/ui/card';
import { Loader2, LogIn, UserPlus } from 'lucide-react';
import { useCustomerAuth } from '../context/CustomerAuthContext';
import { useT } from '../context/I18nContext';
import { toast } from 'sonner';

const AccountLogin = () => {
  const { login } = useCustomerAuth();
  const { t } = useT();
  const [form, setForm] = useState({ email: '', password: '' });
  const [submitting, setSubmitting] = useState(false);
  const nav = useNavigate();
  const loc = useLocation();
  const returnTo = new URLSearchParams(loc.search).get('return') || '/checkout';

  const submit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    try {
      await login(form);
      toast.success('Signed in');
      nav(returnTo);
    } catch (err) {
      toast.error(err?.response?.data?.detail || 'Login failed');
    } finally { setSubmitting(false); }
  };

  return (
    <>
      <Header />
      <main className="bg-black min-h-[60vh]">
        <div className="max-w-md mx-auto px-6 py-16">
          <Card className="bg-zinc-950 border-zinc-900 p-8" data-testid="account-login-card">
            <div className="text-center mb-6">
              <LogIn className="h-8 w-8 mx-auto mb-2 text-[#d4af37]" />
              <h1 className="serif-italic gold-gradient-text text-3xl">{t('account.login_title')}</h1>
              <p className="text-zinc-400 text-sm mt-2">{t('account.login_subtitle')}</p>
            </div>
            <form onSubmit={submit} className="space-y-4">
              <div>
                <Label className="text-zinc-300">{t('checkout.email')}</Label>
                <Input required type="email" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} className="bg-transparent border-zinc-800 mt-1" data-testid="account-login-email" />
              </div>
              <div>
                <Label className="text-zinc-300">{t('account.password')}</Label>
                <Input required type="password" value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} className="bg-transparent border-zinc-800 mt-1" data-testid="account-login-password" />
              </div>
              <Button type="submit" disabled={submitting} className="btn-gold w-full h-11" data-testid="account-login-submit">
                {submitting ? <><Loader2 className="h-4 w-4 mr-2 animate-spin" />…</> : t('account.sign_in')}
              </Button>
            </form>
            <p className="text-zinc-500 text-sm text-center mt-5">
              {t('account.no_account')}{' '}
              <Link to={`/register?return=${encodeURIComponent(returnTo)}`} className="text-[#d4af37] underline" data-testid="account-goto-register">{t('account.create_account')}</Link>
            </p>
          </Card>
        </div>
      </main>
      <Footer />
    </>
  );
};

export default AccountLogin;
